import React, { PureComponent } from "react";
import CheckboxGroup from "../../form/CheckboxGroup";
import Checkbox from "../../form/Checkbox";
import FilterGroup from "../FilterGroup";

class HardballFilter extends PureComponent {
  render() {
    return (
      <FilterGroup title="Hardballs">
        <CheckboxGroup
          checked={this.props.checked}
          onChangeHandler={this.props.onChangeHandler}
        >
          <Checkbox value="hardballs" label="Hardballs Only" />
        </CheckboxGroup>
      </FilterGroup>
    );
  }
}

export default HardballFilter;



// WEBPACK FOOTER //
// ./src/components/filters/options/HardballFilter.js